// src/helpers/CreateMockListResponse.ts
var e = (e, t) => (n, r, i) => {
	let a = Array.from({ length: n }, (t, n) => e(n));
	t && (a = a.filter(t));
	let o = a.length;
	r ??= 0, i ??= o;
	let s = a.slice(r * i, (r + 1) * i);
	return {
		totalEntries: o,
		totalPages: Math.ceil(o / i) || 0,
		page: r,
		perPage: i,
		items: s
	};
};
export { e as createMockListResponse };

//# sourceMappingURL=CreateMockListResponse.js.map